// «Избранное»: матчи группами по дням (макет 1073:19579) и рекомендации строками со звездой (1073:20133 / 1073:19660).
import { useNavigate } from 'react-router-dom';
import type { LeagueCard, PlayerCard } from '../../api/favoritesTypes';
import type { TeamCard } from '../../api/homeTypes';
import type { MatchRow } from '../../api/types';
import { paths } from '../../nav';
import type { FavType } from '../../session/favorites';
import { Avatar } from '../../ui/Avatar';
import { FavoriteStar } from '../../ui/FavoriteStar';
import { MatchRowView } from '../../ui/MatchRowView';
import { TeamLogo } from '../../ui/TeamLogo';
import { dateOfDay, useLocalToday } from '../useLocalToday';
import { groupByDay } from './favModel';
import styles from './FavSections.module.css';

/** Матчи одной лентой по дням: «Sat, 17 Oct» · «Yesterday, 19 Oct» · «Today, 20 Oct» · «Tomorrow, 21 Oct». */
export function MatchDays({ matches }: { matches: MatchRow[] }) {
  const navigate = useNavigate();
  // «сегодня» из часов устройства с подпиской: за полночь «Today» становится «Yesterday» без перезапуска (HQ-1821)
  const groups = groupByDay(matches, dateOfDay(useLocalToday()));
  return (
    <>
      {groups.map((group) => (
        <section key={group.key} className={styles.day} data-day={group.key}>
          <h2 className={styles.heading}>{group.title}</h2>
          {group.matches.map((match) => (
            <div key={match.id} className={styles.matchCard}>
              <MatchRowView match={match} showLeague={false} meta={false} timeOnly onOpen={(id) => navigate(paths.match(id))} />
            </div>
          ))}
        </section>
      ))}
    </>
  );
}

/** Заголовок рекомендаций 16/600 (Figma «Recommendations», Menu Cell I1073:20355;13332:47001). */
export function SectionHeading({ children }: { children: string }) {
  return <h2 className={styles.recsHeading}>{children}</h2>;
}

/** Строка рекомендации (Figma Menu Cell I1073:20355;13332:47002): круг 40 — значок 24 (команда, турнир) или фото игрока
 *  со значком его команды 12 (card.team.image; нет картинки — без значка); имя 16/400; звезда — добавить в один тап. */
export function RecommendationRow({ type, card }: { type: FavType; card: TeamCard | LeagueCard | PlayerCard }) {
  const navigate = useNavigate();
  const open = () => navigate(type === 'team' ? paths.team(card.id) : type === 'league' ? paths.league(card.id) : paths.player(card.id));
  const badge = type === 'player' ? (card as PlayerCard).team : null;
  return (
    <div className={styles.recRow}>
      <button className={styles.recOpen} onClick={open}>
        <span className={styles.recLogo}>
          {type === 'player'
            ? <Avatar src={card.image} name={card.name} size={40} kind="person" />
            : <TeamLogo src={card.image} code={'code' in card ? card.code : null} size={24} />}
          {badge?.image && <span className={styles.recBadge}><TeamLogo src={badge.image} code={badge.code} size={12} /></span>}
        </span>
        <span className={styles.recName}>{card.name}</span>
      </button>
      <FavoriteStar type={type} id={card.id} />
    </div>
  );
}
